export const queueDropdownCallback = [
    {
        value: "Blue Queue",
        name: "Blue Queue",
    }
  ];
  